import { FeatureFlag } from '../FeatureFlag';

export const enableCsvOrderUpload = new FeatureFlag({
    key: 'enable-csv-order-upload',
    createdOn: '2025-07-22',
    defaultValue: false,
});
